import React from "react";
import { withUserProfile } from "../../../../userProfile/userProfileContext";
import { withStyles, Checkbox, FormControlLabel } from "@material-ui/core";
import { compose } from "recompose";
import { getDataWithQueryString } from "../../../../api/componentAPIs";
import DataGrid from "../../../dataGrid";
import GridConfig from "./GridConfig";
import styles from "../../Settings/styles";
import SaveAltSharp from "@material-ui/icons/SaveAltSharp";
import CallMergeIcon from "@material-ui/icons/CallMerge";
import Tooltip from "../../../common/StyledToolTip";
import SearchBox from "../../../common/SearchBox";
import MergeStops from "../../IBPlanning/Common/MergeStops/index";
import { withSnackbar } from "notistack";
import { MERGE_TYPES } from "../../IBPlanning/Common/MergeStops/utills";
import MergeStopAlert from "../../IBPlanning/Common/MergeStops/MergeStopAlert";
import { csvFormulaInjectionSanitizer } from "../../../../utilities/csvUtils";
import { v4 as uuidv4 } from "uuid";
import ClearAllFilterButton from "../../../dataGrid/columnFilters/ClearAllFilterButton";

class DuplicateCustomers extends React.Component {
  constructor(props) {
    super(props);
    this.gridConfig = new GridConfig();
    this.gridApi = null;
    this.state = {
      duplicateCustomerData: null,
      filteredDuplicateCustomerData: null,
      quickFilterText: "",
      selectedCustomers: [],
      showMergeCustomerPopup: false,
      showMergeCustomerAlert: false,
      excludeTrapRoute: true,
    };
  }
  onGridReady = ({ api }) => {
    this.gridApi = api;
  };

  updateQuickFilterText = (value) => {
    this.setState({
      quickFilterText: value,
    });
  };

  exportCSV = () => {
    if (!this.state.duplicateCustomerData.length || !this.gridApi) {
      return;
    }
    const columnIds = this.gridApi.columnController
      .getAllGridColumns()
      .reduce((columnKeys, column) => {
        if (column.colDef.headerName) {
          columnKeys.push(column.colId);
        }
        return columnKeys;
      }, []);
    const params = {
      fileName: "Duplicate_Customer_Report",
      columnKeys: columnIds,
      processCellCallback: (cell) => csvFormulaInjectionSanitizer(cell.value)
    };
    this.gridApi.exportDataAsCsv(params);
  };
  componentDidMount() {
    this._isComponentMounted = true;
    this.getDuplicateCustomer();
  }

  componentWillUnmount() {
    this._isComponentMounted = false;
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.userData.userProfile.scenarioID !==
      this.props.userData.userProfile.scenarioID
    ) {
      this.getDuplicateCustomer();
    }
  }

  getDuplicateCustomer = () => {
    getDataWithQueryString(
      "GetDuplicateCustomer",
      `scenarioId=${this.props.userData.userProfile.scenarioID}`
    ).then(
      (response) => {
        if (this._isComponentMounted) {
          if (response.status === 200) {
            this.setState({
              duplicateCustomerData: response.data,
              filteredDuplicateCustomerData: this.getFilteredDuplicateCustomers(
                this.state.excludeTrapRoute,
                response.data
              ),
            });
          } else {
            this.setState({
              duplicateCustomerData: [],
              filteredDuplicateCustomerData: [],
            });
          }
        }
      },
      (error) => {
        if (this._isComponentMounted) {
          this.setState({
            duplicateCustomerData: [],
            filteredDuplicateCustomerData: [],
          });
        }
      }
    );
  };

  onCancelMergeCustomers = () => {
    this.setState({ showMergeCustomerPopup: false });
  };

  onMergeCustomerCompleted = () => {
    this.getDuplicateCustomer();
  };

  onCancelMergeCustomerAlert = () => {
    this.setState({ showMergeCustomerAlert: false });
  };

  onConfirmMergeCustomerAlert = () => {
    this.setState({
      showMergeCustomerAlert: false,
      showMergeCustomerPopup: true,
    });
  };

  onCellFocused = (params) => {
    if (this.state.showMergeCustomerPopup) {
      this.setState({ showMergeCustomerAlert: true });
    }
  };

  handleTrapFilter = (event) => {
    const filteredDuplicateCustomerData = this.getFilteredDuplicateCustomers(
      event.target.checked,
      this.state.duplicateCustomerData
    );
    this.setState({
      filteredDuplicateCustomerData: filteredDuplicateCustomerData,
      excludeTrapRoute: event.target.checked,
    });
  };

  getFilteredDuplicateCustomers = (excludeTrapRoute, duplicateCustomerData) => {
    const trapGroupIdList = duplicateCustomerData.reduce((trapGroupIdList, customer) => {
      return customer.isTrapRoute
        ? [...trapGroupIdList, customer.groupId]
        : [...trapGroupIdList];
    }, []);
    return excludeTrapRoute
      ? duplicateCustomerData.filter(
          (customer) => !trapGroupIdList.includes(customer.groupId)
        )
      : duplicateCustomerData;
  };

  onSelectionChanged = () => {
    const selectedCustomers = this.gridApi.getSelectedRows();
    this.setState({
      selectedCustomers: selectedCustomers.map((customer, i) => {
        return {
          ...customer,
          routeName: customer.route,
          consigneeName: customer.customer,
          customerPreferredRouteName: "",
          consigneeId: customer.customerID,
          consigneeAddress: customer.address,
          key: uuidv4(),
        };
      }),
    });
  };

  mergeCustomers = () => {
    const isTrapIncludes = this.state.selectedCustomers.filter(
      (customer) => customer.isTrapRoute
    );
    if (isTrapIncludes.length > 0) {
      this.props.enqueueSnackbar("Trap routes customers can not be merged.", {
        variant: "error",
      });
    } else {
      const groupIdList = [
        ...new Set(
          this.state.selectedCustomers.map((customer) => customer.groupId)
        ),
      ];
      if (groupIdList.length === 1) {
        this.setState({ showMergeCustomerPopup: true });
      } else {
        this.props.enqueueSnackbar(
          "You can only merge customers with same address.",
          {
            variant: "error",
          }
        );
      }
    }
  };

  render() {
    const { classes } = this.props;
    const { config } = this.gridConfig;
    const enableMergeCustomerIcon = this.state.selectedCustomers.length >= 2;
    return (
      <div className={classes.duplicateCustomerSubModule}>
        <header
          className={`${classes.moduleHeader} ${classes.reportsIBPlanningGridHeader}`}
        >
          <span>Duplicate Customers</span>
          <div className={classes.gridActionIcons}>
            <div className={classes.excludeTrap}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.excludeTrapRoute}
                    onChange={this.handleTrapFilter}
                    color="primary"
                  />
                }
                label={<span className={classes.text}>Exclude Trap Routes</span>}
              />
            </div>
            <span
              onClick={enableMergeCustomerIcon ? this.mergeCustomers : null}
              className={`${classes.mergeIconStyles} ${
                enableMergeCustomerIcon
                  ? classes.enabledIcon
                  : classes.disableIcon
              }`}
            >
              <Tooltip
                title={
                  enableMergeCustomerIcon
                    ? "Merge Customers"
                    : "Select at least two customers to merge"
                }
              >
                <CallMergeIcon />
              </Tooltip>
            </span>
            <SearchBox onChange={this.updateQuickFilterText} />
            <ClearAllFilterButton gridApi={this.gridApi} />
            <span onClick={this.exportCSV} className={classes.headerIconStyles}>
              <Tooltip title="Export Data">
                <SaveAltSharp />
              </Tooltip>
            </span>
          </div>
        </header>
        <div className={classes.reportsIBPlanningGridContainer}>
          <div className={`${classes.dataGrid} ${classes.anchorPointContent}`}>
            <DataGrid
              defaultColDef={config.defaultColDef}
              columnDefs={config.columns}
              config={config}
              rowData={this.state.filteredDuplicateCustomerData}
              enableSorting={config.enableSorting}
              onGridReady={this.onGridReady}
              quickFilterText={this.state.quickFilterText}
              rowSelection={this.gridConfig.config.rowSelection}
              rowDeselection={this.gridConfig.config.rowDeselection}
              onSelectionChanged={this.onSelectionChanged}
              onCellMouseDown={this.onCellFocused}
              suppressRowClickSelection={this.state.showMergeCustomerPopup}
            />
          </div>
        </div>
        {this.state.showMergeCustomerPopup && (
          <MergeStops
            open
            onClose={this.onCancelMergeCustomers}
            selectedStops={this.state.selectedCustomers}
            glEventHub={this.props.glEventHub}
            mergeType={MERGE_TYPES.Customers}
            onMergeCompleted={this.onMergeCustomerCompleted}
          />
        )}
        {this.state.showMergeCustomerAlert && (
          <MergeStopAlert
            onCancel={this.onCancelMergeCustomerAlert}
            onConfirm={this.onConfirmMergeCustomerAlert}
            inProgress={this.state.showMergeCustomerPopup}
          />
        )}
      </div>
    );
  }
}
export default compose(
  withStyles(styles),
  withUserProfile,
  withSnackbar
)(DuplicateCustomers);
